import { render } from "./TheCheckbox.vue?vue&type=template&id=1443a292&scoped=true"
import script from "./TheCheckbox.vue?vue&type=script&lang=js"
export * from "./TheCheckbox.vue?vue&type=script&lang=js"

import "./TheCheckbox.vue?vue&type=style&index=0&id=1443a292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1443a292"]])

export default __exports__